import { formatTime } from '@/scenarios/legacy-player/components/PlayerSkin/hooks/useFormattedTime';

import { Time } from '../../types/time';
import { Duration } from '../../types/duration';

export const getFormattedTime = (currentTime: Time, duration: Duration) => {
    const roundValue = Math.floor(duration.getSecondsTillEnd(currentTime));
    const roundDuration = duration ? Math.floor(duration.visibleDuration) : 0;
    return formatTime(roundValue, roundDuration)[0];
};
